module.exports = __webpack_public_path__ + "static/16c070a70cf7108b1fee3085c1250ac331361f4c4d563e80c022b0151a95b9b5-e8e7609443bd7921b6348ed1464b202d.jpeg";